<template>
    <router-link :to="{name: 'object', params: {id}}" class="ObjectMoreInfoLink">
            <div class="ObjectMoreInfoLink__text">
                <slot>Подробнее</slot>
            </div>
        <ArrowIcon/>
    </router-link>
</template>

<script>
import ArrowIcon from "@/assets/image/icons/arrow_right.svg?inline";

export default {
    name: "ObjectMoreInfoLink",
    components: {
        ArrowIcon,
    },
    props: {
        id: [Number, String]
    }
}
</script>

<style lang="scss">
.ObjectMoreInfoLink {
  padding: 6px 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  &__text {
    height: 100%;
    font-weight: 500;
    margin-right: 5px;
  }
}
</style>
